export default function _minutesList() {
    // Check if the module exists before doing anything
    const minutesListExists = !!document.querySelector('.minutes-list');

    // If the module exists, do whatever we need to
    if (minutesListExists) {
        // Your code here
        console.log('Minutes list JS');
    }
}
_minutesList();
